export const toCappedCountText = (count: number, max = 99): string => {
  if (count > max) return `${max}+`;
  else return `${count}`;
};
